import { rei } from "@/services/api"

class ProcedimentoService {
  static getProcedimentos (params) {
    return rei.get(`procedimento`, {params}).then(res => res.data)
  }

  static cadastrarProcedimento (procedimento) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }
    const formData = new FormData()

    Object.keys(procedimento).forEach(key => {
      if (key === 'procedimentoArquivo') {
        procedimento.procedimentoArquivo.forEach(file => {
          formData.append('files[]', file)
        })
      } else if (procedimento[key]) {
        formData.append(key, procedimento[key])
      }
    })

    return rei.post(`procedimento`, formData, config).then(res => res.data)
  }

  static atualizarProcedimento (procedimento, id) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }
    const formData = new FormData()

    Object.keys(procedimento).forEach(key => {
      if (!procedimento[key]) return

      if (key === 'procedimentoArquivo') {
        procedimento.procedimentoArquivo.forEach(file => {
          if (!file.pdf) formData.append('files[]', file)
        })
      } else if (key === 'deleteds') {
        procedimento.deleteds.forEach(item => {
          formData.append('deleteds[]', item)
        })
      } else {
        formData.append(key, procedimento[key])
      }
    })
    return rei.put(`procedimento/${id}`, formData, config).then(res => res.data)
  }

  static excluirProcedimento (id) {
    return rei.delete(`procedimento/${id}`)
  }

  static getDocumentos (id) {
    return rei.get(`procedimento-arquivo/${id}`).then(res => res.data)
  }

  static getPDF (url) {
    const config = {
      responseType: 'arraybuffer'
    }

    return rei.get(`visualizar-arquivo-procedimento?url_s3=${url}`, config).then(res => res.data)
  }
}

export default ProcedimentoService
